import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import "./SuccessHandler.sass";
import { BASE } from "../basedata/constants";
import { apiUser } from "../basedata/apiCall";
import { useStep } from "../context/StepContext"
import Illustration from "../components/Illustration/Illustration";

const SuccessHandler = () => {
  const { t } = useTranslation(); 
  const { setStep } = useStep();
  const [accepted, setAccepted] = useState(false);

  const [clearFlow, setClearFlow] = useState(false);

  const [buyLink, setBuyLink] = useState(BASE.company.call_to_action.ticket);



  const verifyBiometry = async (userToken:any) => {
    try{
      const _response = await apiUser.post(`/biometry/onboarding/user-jorney`, {flowId: userToken})
      if(_response.data.status === 'success'){
        sessionStorage.setItem('document_type', _response.data.document_type || 'cpf')
        const _current_location = window.location.pathname
        if(_response.data.message === 'done'){
            return setBuyLink(_response.data.userInformation?.callbackURL || BASE.company.call_to_action.ticket)
        }else{
          return window.location.href = '/'
        }
      }

      setTimeout(() => {
        verifyBiometry(userToken)
      }, 3000);
    }catch(e){
      setTimeout(() => {
        verifyBiometry(userToken)
      }, 3000);
    }
  }

  useEffect(() => {
    setStep(6);
    verifyBiometry(window.sessionStorage.getItem('token'))
  }, [])


  useEffect(() => {
    const _temp_language = sessionStorage.getItem('language') || 'pt'
    const _clearFlow = sessionStorage.getItem('clear_flow')
    const _temptoken = sessionStorage.getItem('token') || ''

    sessionStorage.clear()
    sessionStorage.setItem('success_flow', 'true')
    sessionStorage.setItem('language', _temp_language)
    sessionStorage.setItem('token', _temptoken)
    if(_clearFlow && _clearFlow === 'true'){
      setClearFlow(true)
    }
  }, []);


  return (
    <div className="success-container">
      <div className="left-side"></div> 
      <div className="right-side">
        <div className="success-card">
          <img className="logo" src={BASE.company.logo} alt={BASE.company.name} />
          <h1 className="success_title">
            {t("success_page.success_title")}
          </h1>
          <div className="success-message-text">
            <p className="success-message">
              {t("success_page.sub_title")}
            </p>
            {clearFlow && (
              <p className="success-message">
                {t("success_page.clear_flow")}
              </p>
            )}
            <p
              className="success-message-info"
              dangerouslySetInnerHTML={{ __html: t("success_page.text_1") }}
            />
          </div>
          {/* <img
            src="/Illustration-success.svg"
            className="no-svg-tip"
            alt="Sucesso!"
          /> */}
          <div className="success-message-text">
            <p className="success-message">
            {t("success_page.text_2")}
            </p>
            <p className="success-message">
              {t("success_page.see_ya")}
            </p>
          </div>
            <button onClick={() => {window.location.href = `${buyLink}`}} className="continue-button">
              {t("success_page.action_button")}
            </button>

            {/* <button onClick={() => {window.location.href = 'https://futebolcard.com'}} className="continue-button btn-ghost">
              {t("success_page.action_guest_button")}
            </button> */}
        </div>
      </div>
    </div>
  );
};

export default SuccessHandler;